import { SaleDocumentKind } from '@skylab-shared/dataModel';

export const kindToAdjustmentMap = {
    [SaleDocumentKind.Invoice]: SaleDocumentKind.InvoiceAdjustment,
    [SaleDocumentKind.VatMarginInvoice]: SaleDocumentKind.VatMarginInvoiceAdjustment,
    [SaleDocumentKind.ProForma]: <null>null,
    [SaleDocumentKind.Receipt]: SaleDocumentKind.ReceiptAdjustment,
    [SaleDocumentKind.AdvanceInvoice]: SaleDocumentKind.AdvanceInvoiceAdjustment
};
